import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withNavigationErrorHandler,
} from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { routes } from '../../app.routes';
import { authInit } from '../auth/auth.init';
import { oauthModuleConfig } from '../auth/auth.config';
import { authErrorInterceptor } from '../auth/auth.interceptor';
import { GlobalErrorHandler } from '../error/global-error-handler';
import { recordError } from '../error/diagnostics';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authErrorInterceptor]), withInterceptorsFromDi()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler((event) => recordError('navigation', event.error)),
    ),
    provideOAuthClient(oauthModuleConfig),
    provideAppInitializer(authInit),
  ],
};
